/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Error_MappingInputs */

const en_svchip_error_mapping = /** @type {(inputs: Svchip_Error_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error mapping`)
};

const ar_svchip_error_mapping = /** @type {(inputs: Svchip_Error_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خرائط الأخطاء`)
};

const bn_svchip_error_mapping = /** @type {(inputs: Svchip_Error_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এরর ম্যাপিং`)
};

const de_svchip_error_mapping = /** @type {(inputs: Svchip_Error_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlerzuordnung`)
};

const es_svchip_error_mapping = /** @type {(inputs: Svchip_Error_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapeo de errores`)
};

const fr_svchip_error_mapping = /** @type {(inputs: Svchip_Error_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartographie des erreurs`)
};

const pt_svchip_error_mapping = /** @type {(inputs: Svchip_Error_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapeamento de erro`)
};

const zh_svchip_error_mapping = /** @type {(inputs: Svchip_Error_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误映射`)
};

const tr_svchip_error_mapping = /** @type {(inputs: Svchip_Error_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hata eşleme`)
};

const ru_svchip_error_mapping = /** @type {(inputs: Svchip_Error_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сопоставление ошибок`)
};

const pl_svchip_error_mapping = /** @type {(inputs: Svchip_Error_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapowanie błędów`)
};

/**
* | output |
* | --- |
* | "Error mapping" |
*
* @param {Svchip_Error_MappingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_error_mapping = /** @type {((inputs?: Svchip_Error_MappingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Error_MappingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_error_mapping(inputs)
	if (locale === "bn") return bn_svchip_error_mapping(inputs)
	if (locale === "de") return de_svchip_error_mapping(inputs)
	if (locale === "es") return es_svchip_error_mapping(inputs)
	if (locale === "fr") return fr_svchip_error_mapping(inputs)
	if (locale === "pt") return pt_svchip_error_mapping(inputs)
	if (locale === "zh") return zh_svchip_error_mapping(inputs)
	if (locale === "tr") return tr_svchip_error_mapping(inputs)
	if (locale === "ru") return ru_svchip_error_mapping(inputs)
	if (locale === "pl") return pl_svchip_error_mapping(inputs)
	return en_svchip_error_mapping(inputs)
});